import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Container, Content } from 'rsuite';
import { LoadingSpiner } from '../../components/LoadingSpinner';
import Warning from '../../components/Warning';

import { resolverDownload, SITUACAO_DOWNLOAD } from '../../services/DownloadService';
import TelasHistorico from './TelasHistorico';

const AVISOS = {
  [SITUACAO_DOWNLOAD.OUTRO_CLIENTE]: {
    titulo: 'Arquivo de outro cliente',
    texto: 'Este arquivo pertence a outro cliente e não pode ser baixado com o seu acesso. Confira se entrou com o usuário certo.',
    historico: false,
  },
  [SITUACAO_DOWNLOAD.INDISPONIVEL]: {
    titulo: 'Arquivo indisponível',
    texto: 'Não encontramos este arquivo. Gere o arquivo de novo ou procure por ele no histórico da tela de origem.',
    historico: true,
  },
  [SITUACAO_DOWNLOAD.FALHA]: {
    titulo: 'Não foi possível baixar o arquivo',
    texto: 'Tente novamente em alguns minutos. Se continuar assim, avise o suporte da InfoPrice.',
    historico: false,
  },
};

const Download = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [situacao, setSituacao] = useState(null);

  useEffect(() => {
    let ativo = true;

    resolverDownload(id).then(resultado => {
      if (!ativo) {
        return;
      }
      if (resultado.situacao === SITUACAO_DOWNLOAD.SEM_LOGIN) {
        history.replace({ pathname: '/login', state: { from: location.pathname } });
        return;
      }
      setSituacao(resultado.situacao);
      if (resultado.situacao === SITUACAO_DOWNLOAD.LIBERADO) {
        window.location.assign(resultado.url);
      }
    });

    return () => {
      ativo = false;
    };
  }, [id, history, location.pathname]);

  const aviso = AVISOS[situacao];

  return (
    <Container className="main-container download-page">
      <LoadingSpiner size="md" />
      <Content className="content">
        {situacao === SITUACAO_DOWNLOAD.LIBERADO && <p>O download do arquivo começou.</p>}
        {aviso && (
          <div role="alert">
            <Warning title={aviso.titulo} description={aviso.texto} />
            {aviso.historico && <TelasHistorico />}
          </div>
        )}
      </Content>
    </Container>
  );
};

export default Download;
